<template>
  <base-page-layout title="Configurações">
    <v-tabs v-model="tab" grow class="mb-5">
      <v-tab to="/configuracoes-admin"> Gerais </v-tab>
      <v-tab to="/configuracoes-admin/televendas"> Televendas </v-tab>
      <v-tab to="/configuracoes-admin/hotsite"> Hotsite </v-tab>
      <v-tab to="/configuracoes-admin/app"> App </v-tab>
      <v-tab to="/configuracoes-admin/termos"> Termos </v-tab>
      <v-tab to="/configuracoes-admin/lojas"> Lojas </v-tab>
      <v-tab to="/configuracoes-admin/integracoes"> Integrações </v-tab>
    </v-tabs>
    <router-view />
  </base-page-layout>
</template>

<script>
import BasePageLayout from '@/components/BasePageLayout.vue'

export default {
  components: {
    BasePageLayout,
  },
  data: () => ({
    tab: 0,
  }),
}
</script>
